// Set JavaScript snippet to use PhraseApp In-Context Editor.
// https://phraseapp.com/docs/guides/in-context-editor/custom-integration/#javascript-snippet
// To avoid the 'ReferenceError: document is not defined', check the existance of 'document' instance.
// https://github.com/nozzle/react-static/issues/288#issuecomment-356356652
if (
  process.env.REACT_APP_PHRASEAPP_IN_CONTEXT_EDITOR_ENABLED === 'true' &&
  typeof document !== 'undefined'
) {
  const script = document.createElement('script');
  script.innerHTML = `
    window.PHRASEAPP_CONFIG = {
      projectId: '${process.env.REACT_APP_PHRASEAPP_PROJECT_ID}',
      autoLowercase: false,
    };
    (function() {
      var phraseapp = document.createElement('script'); phraseapp.type = 'text/javascript'; phraseapp.async = true;
      phraseapp.src = ['https://', 'phraseapp.com/assets/in-context-editor/2.0/app.js?', new Date().getTime()].join('');
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(phraseapp, s);
    })();
  `;
  script.async = true;
  document.body.appendChild(script);
}



// WEBPACK FOOTER //
// ../src/htmlJobs.js